import OptionsAPI from '@/api/options';
import { parseCustomMenu } from '@/libs/customMenu';

export default {
    namespaced: true,
    state(){
        return {
            baseOptions: null,
            customMenu: null,
        }
    },
    getters:{
        bottomMenuItem(state) {
            if (!state.customMenu?.bottomItemId) {
                return null;
            }

            return state.customMenu.items.find(item => item.id === state.customMenu.bottomItemId) || null;
        },
    },
    actions:{
        async getBaseOptions({state, commit}){
            if(!state.baseOptions){
                const bOpts = await OptionsAPI.getBaseOptions();
                commit('setBaseOptions', bOpts);
            }
            return state.baseOptions;
        },
        async getBaseOption({state, dispatch}, name){
            if(!state.baseOptions){
                await dispatch('getBaseOptions');
            }
            return state.baseOptions[name] ?? null;
        },
        async getCustomMenu({ state, commit }) {
            if (!state.customMenu) {
                const menu = await OptionsAPI.getCustomMenu();
                commit('setCustomMenu', menu);
            }

            return state.customMenu;
        },
    },
    mutations:{
        setBaseOptions(state, bOpts){
            if(bOpts === null) bOpts = {};
            state.baseOptions = bOpts;
        },
        setCustomMenu(state, menu) {
            state.customMenu = parseCustomMenu(menu);
        },
    }
  }
